export var euiColorPrimary = {"r":35,"g":140,"b":255,"a":1,"rgba":"rgba(35, 140, 255, 1)"}
export var euiColorPrimaryText = {"r":35,"g":140,"b":255,"a":1,"rgba":"rgba(35, 140, 255, 1)"}
export default {"euiColorPrimary":{"r":35,"g":140,"b":255,"a":1,"rgba":"rgba(35, 140, 255, 1)"},"euiColorPrimaryText":{"r":35,"g":140,"b":255,"a":1,"rgba":"rgba(35, 140, 255, 1)"}}
